import React from "react";
import { Spinner } from "react-bootstrap";

const FullScreenLoader: React.FC = () => {
  return (
    <div className="pz-loader" aria-busy="true">
      <Spinner animation="border" role="status" />
      <div className="pz-loader__text">Loading…</div>
    </div>
  );
};

export default FullScreenLoader;
